class RichTextFieldHelpers {
  /** Parse "#<id>#\n<content>" blocks into a map */
  static parseSummaries = (value: string): Record<string, string> => {
    const map: Record<string, string> = {};
    if (!value) return map;

    // Match blocks like:
    // #9#
    // some text...
    // #12#
    // another text...
    // const blockRegex = /^#(\d+)#\s*([\s\S]*?)(?=^#\d+#|\s*\Z)/gm;
    // const blockRegex = /^#(\d+)#\s*([\s\S]*?)(?=^#\d+#|$)/gm;
    const blockRegex = /^#(\d+)#\s*([\s\S]*?)(?=^#\d+#|(?![\s\S]))/gm;
    let m: RegExpExecArray | null;
    while ((m = blockRegex.exec(value)) !== null) {
      const id = m[1];
      const body = (m[2] ?? '').trim();
      map[id] = body;
    }
    // If no blocks were found, treat entire value as a single unscoped text (optional)
    if (Object.keys(map).length === 0 && value?.trim()) {
      map['__unscoped__'] = value.trim();
    }
    return map;
  };

  /** Serialize map back to blocks (sorted by id, unscoped last) */
  static serializeSummaries = (map: Record<string, string>): string => {
    const entries = Object.entries(map);
    const scoped = entries
      .filter(([k]) => k !== '__unscoped__')
      .sort((a, b) => Number(a[0]) - Number(b[0]));
    const unscoped = entries.filter(([k]) => k === '__unscoped__');

    const parts: string[] = [];
    for (const [id, body] of scoped) {
      parts.push(`#${id}#\n${(body ?? '').trim()}`);
    }
    for (const [, body] of unscoped) {
      // keep as-is if someone previously stored free text without markers
      parts.push((body ?? '').trim());
    }
    return parts.join('\n\n');
  };

  static parseMarkdownCustom = (markdown: string): string => {
    // For some reason, the editor makes '-' into '\\-', need to revert that
    let fixedMarkdown = markdown.replace(/^\\-/gm, '-');
    // convert \\- to \- (at the start of the lines)
    fixedMarkdown = fixedMarkdown.replace(/^\\\\-/gm, '\\-');
    // editor uses <u>...</u> for underline, convert back to __...__
    fixedMarkdown = fixedMarkdown.replace(/<u>(.*?)<\/u>/g, '__$1__');
    // Remove \\ from any _ that is not followed by another _
    fixedMarkdown = fixedMarkdown.replace(/\\_(?!_)/g, '_');
    // Remove &#x20; (space) artifacts
    fixedMarkdown = fixedMarkdown.replace(/&#x20;/g, ' ');
    return fixedMarkdown;
  };

  static transformToEditorMarkdown = (markdown: string): string => {
    // Convert __underline__ to <u>underline</u> for the editor display
    let transformed = markdown.replace(/__([\s\S]*?)__/g, '<u>$1</u>');
    // Escape '-' to '\\-' so the editor doesn't treat them as list items
    transformed = transformed.replace(/^\\-/gm, '\\\\-');
    // If there is a space at the end of a line, replace with &#x20; to preserve it
    transformed = transformed.replace(/ +$/gm, (match) =>
      '&#x20;'.repeat(match.length),
    );
    return transformed;
  };
}

export default RichTextFieldHelpers;
